import { useEffect, useState } from 'react';
import { useWallet } from '../context/WalletContext';
import { useContracts } from './useContracts';
import { useUserData } from './useUserData';

// Aggregate team stats from storage view calls.
// - directCount   → summary.directReferrals
// - totalTeam     → sum of userLevelCounts across all 30 levels
// - directBiz     → sum of leg business for user's directs
// - totalBiz      → sum of level volumes across all 30 levels
export const useTeamStats = () => {
  const { account } = useWallet();
  const c = useContracts();
  const { userId } = useUserData();
  const [state, setState] = useState({
    loading: true,
    directCount: 0n,
    totalTeam: 0n,
    directBiz: 0n,
    totalBiz: 0n,
  });

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!account || !userId || userId === 0n) {
        if (mounted) setState((s) => ({ ...s, loading: false }));
        return;
      }
      try {
        const [counts, vols, legs] = await Promise.all([
          c.read.store.getUserLevelCounts(userId),
          c.read.store.getUserLevelVolumes(userId),
          c.read.views.getUserLegs(userId),
        ]);
        let totalTeam = 0n;
        let totalBiz = 0n;
        for (let i = 0; i < 30; i++) {
          totalTeam += BigInt(counts[i]);
          totalBiz += BigInt(vols[i]);
        }
        let directBiz = 0n;
        for (const leg of legs) directBiz += BigInt(leg.legBusinessUSDT);
        if (!mounted) return;
        setState({
          loading: false,
          directCount: BigInt(legs.length),
          totalTeam,
          directBiz,
          totalBiz,
        });
      } catch {
        if (mounted) setState((s) => ({ ...s, loading: false }));
      }
    })();
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, userId]);

  return state;
};
